module.exports = __webpack_public_path__ + "img/packing-3.4e611295.png";